export const Team = [
    {
        title: 'ollionaire',
        url: '#',
        desc: 'Ex-Head at Universal Pictures. 20+ big-screen credits (Transformers 2-7, The Avengers, Thor, The Wolverine, and Terminator Genisys). Currently heads a studio, working with Netflix, Riot Games, and Warner Bros. Only compatible with Windows 7.',
        twitter: "https://twitter.com/TheOllionaire"
    },
    {
        title: 'chromedoves',
        url: '#',
        desc: 'Ex-Goldman Sachs investment banker. Still trying to get reservations at Dorsia. Do it because it’s fun - I’ve been playing with bubbles since I was 5.',
        twitter: "https://twitter.com/chromedoves"
    },
    {
        title: 'minor miracle',
        url: '#',
        desc: 'Ex-FAANG, startup engineer. Used to building systems, currently building a vibe. Mom does not approve.',
        twitter: "https://twitter.com/xminormiracle"
    },
]